/* ==========================================================================
   a11y-announce.js — screen-reader status announcements (WCAG 4.1.3)
   PR 6 (Live Regions).

   The theme updates the cart count, filter results, etc. by mutating the DOM
   directly, so screen-reader users get no feedback. This helper writes a
   message into a shared ARIA live region so those updates are announced.

   Two regions are rendered in theme.liquid:
     #a11y-announce            (aria-live="polite")    — default
     #a11y-announce-assertive  (aria-live="assertive") — urgent

   Usage:
     a11yAnnounce('Item added to cart');
     a11yAnnounce('Error: out of stock', 'assertive');
   ========================================================================== */
window.a11yAnnounce = function (message, priority) {
  if (!message) return;
  var id =
    priority === "assertive" ? "a11y-announce-assertive" : "a11y-announce";
  var region = document.getElementById(id);
  if (!region) return;

  // Clear first, then set after a tick — re-setting identical text would
  // otherwise not be picked up as a change by some screen readers.
  region.textContent = "";
  window.setTimeout(function () {
    region.textContent = message;
  }, 120);
};
